import { IApplicationState } from 'app/types/types';
import { getPricingProducts } from 'app/view/react_components/dialogs/price_page/selectors/getPricingProducts';
import { EProductFrequency, EProductPack } from 'app/view/react_components/dialogs/price_page/types';
import { connect } from 'react-redux';
import { DemoButton } from '../../components/demoButton/DemoButton';
import { IDemoButtonEvents, IDemoButtonFields } from '../../components/demoButton/types';
import { onClick } from './events/onClick';
import { onPurchaseClick } from './events/onPurchaseClick';

const mapStateToProps = (
    state: IApplicationState
): IDemoButtonFields => {
    const price = +(getPricingProducts(state)[EProductFrequency.ANNUALLY][EProductPack.ESSENTIAL].price / 12).toFixed(2);

    return {
        price,
    }
};

const mapDispatchToProps = (
    dispatch: any
): IDemoButtonEvents => {
    return {
        onClick: () => dispatch(onClick()),
        onPurchaseClick: () => dispatch(onPurchaseClick()),
    }
};

export const DemoButtonHOC = connect(mapStateToProps, mapDispatchToProps)(DemoButton);
DemoButtonHOC.displayName = 'DemoButtonHOC';
